export default __webpack_public_path__ + "static/media/created.f062f5e5.svg";